import React, { useEffect, useState, useRef, useContext } from "react";
import ReactGA from 'react-ga4';
import { useNavigate, Link, useParams } from 'react-router-dom';
import Lang from '../lang/translations';
import Context from '../context/context';
import PopupGenerico from '../popup/popupGenerico';
import Recensioni from '../recensioni/recensioni';
import helpers from "../_helpers/helpersFunction";
import Button from 'react-bootstrap/Button'

const config = require("../_helpers/configServizi");

import Module3ds_adyen from "./forms/adyen/3ds_module";
import Module3ds_trpay from "./forms/trustPay/3ds_module";
import Module3ds_maxpay from "./forms/maxpay/3ds_module";

import { GTMEvents } from '../_helpers/gtm/gtm';
import authHeader from '../../userServices/authHeader';

export default function PianiAbbonamento() {


    let navigate = useNavigate();
    let params = useParams();
    const context = useContext(Context)
    const [spinner, setSpinner] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [termsCompliant, setTermsCompliant] = useState(false);
    const [activeError, setActiveError] = useState(false);
    const [contenuto, setContenuto] = useState({});
    const [selected, setSelected] = useState();
    const [plans, setPlans] = useState([]);
    const [plans_info, setPlansInfo] = useState([]);

    const { collection_folder, default_folder } = helpers.getCDNfolder()

    const [module3ds, setModule_3ds] = useState();
    const [props_3ds, setProps_3ds] = useState();




    function definisciRateplans() {

        if (context.flusso.rateplan != undefined) {

            if (context.fluxId === "0000") {
                //---------- rateplan compliant
                console.log("compliant rateplan", context.flusso.rateplan)
                if (context.premiumLevel == 0) {
                    console.log("compliant free", context.flusso.rateplan.compliant)
                    var rateplans = context.flusso.rateplan.compliant;
                } else {
                    console.log("compliant premium", context.flusso.rateplan.premium)
                    var rateplans = context.flusso.rateplan.premium;
                }
            } else {
                if (context.premiumLevel == 0) {
                    if (context.flusso.rateplan && context.flusso.rateplan.free) {
                        var rateplans = context.flusso.rateplan.free;
                    }
                } else {
                    var rateplans = context.flusso.rateplan.premium;
                }
            }

            return rateplans
        }
    }


    function trovaSelected(piani) {

        
        for (let i = 0; i < piani.length; i++) {
            if (piani[i].product_id == context.rateplanScelto.product_id) {
                return i
            }

            if (piani[i].evidenziato == true) {
                return i
            }
        }

        return 0
    }

    function RenderRateplans() {
        try {
            var temp = []
            if (plans && plans.length > 0) {

                for (let i = 0; i < plans.length; i++) {
                    if (plans[i].visibile == true) {
                        if (context.premiumLevel == 0) {
                            temp.push(creaRigaRateplan(plans[i], i))
                        } else {
                            if (!plans[i].first_selling) {
                                temp.push(creaRigaRateplan(plans[i], i))
                            }
                        }

                    }
                    if (plans[i].spacing_bottom == true) {
                        temp.push(spacing())
                    }
                    if (context.fluxId == "0000") {
                        if (i + 1 == Object.keys(plans).length) {
                            temp.push(disclaimer());
                        }
                    }
                }

                return temp;
            }
            return (<div></div>)
        } catch (err) {
            helpers.logToBackend("NON HO TROVATO RATEPLAN")
        }

    }


    function creaRigaRateplan(rateplan, index) {
        return (<div key={index} onClick={() => { redirOrPurchase(rateplan, index, false); }} className={index == selected ? "contenitoreRiga planSelected rigaNormale" : "contenitoreRiga rigaNormale"}>

            <div className={index == selected ? "w65 rateDescription d-flex" : "w65 rateDescription d-flex"}>
                <blockquote className="blockquote mb-0 flex_column">
                    <span className="nomePiano">{rateplan.nomePiano}</span>
                    {rateplan.descrizionePiano && (<span className="descrizionePiano"><>{rateplan.descrizionePiano}</></span>)}

                    {rateplan.badge && (<span className="promo" >{rateplan.badge}</span>)}
                </blockquote>
                <blockquote className="alignContentCenter">
                    {rateplan.description && (<span className="planDesc" style={{ color: rateplan.description_color }}>{rateplan.description}</span>)}
                </blockquote>
                {rateplan.suggestion && (<div class="middle_box"><p class="mini_badge "><span class="suggestion" style={{ color: rateplan.suggestion_color }}>{rateplan.suggestion}</span></p></div>)}
            </div>
            <div className={index == selected ? "w35 ratePrice alignContentCenter " : "w35 ratePrice alignContentCenter"}>
                {rateplan.vecchioPrezzo && (<span><del>{rateplan.vecchioPrezzo}</del></span>)}
                {rateplan.prezzo && (<span>{rateplan.prezzo}</span>)}
                {rateplan.prezzoDescription && (<span>{rateplan.prezzoDescription}</span>)}

            </div>
        </div>)
    }


    function RenderVerificaEta() {
        return <div className="align-center">
            <div className="ModalAgeVerification">
                <div>18+</div>
            </div>
            <div className="dislaimer_verifica_eta">
                <Lang w={"testo_verifica_eta"} page={"pianiAbbonamento"} />
            </div>
        </div>
    }

    function spacing() {
        return (<div style={{ height: "30px" }}></div>)
    }

    function disclaimer() {
        return (<div className="disclaimer">
            <div className={activeError ? "activeError" : ""} >
                <input className="mr-2"
                    type="checkbox"
                    onChange={(event) => { setTermsCompliant(!termsCompliant); setActiveError(false) }}
                    checked={termsCompliant}
                />
                {context.premiumLevel == 0 ?
                    (<>
                        <span style={{ color: activeError ? 'red' : 'inherit' }}>{Lang({ "w": "disclaimer4", "page": "pianiAbbonamento", "placeholders": { terms: config.servizi[window.location.hostname].legal_link.termini, privacy: config.servizi[window.location.hostname].legal_link.termini } })}</span><br />

                        <br />
                        {(context.fluxId === "0000" && plans_info.tipologia_rateplan === "abbonamento" ) && <span className="piccolino">{Lang({ "w": "discplaimer5", "page": "pianiAbbonamento" })}</span>}

                    </>) :
                    (<span style={{ color: activeError ? 'red' : 'inherit' }}>{Lang({ "w": "disclaimer", "page": "pianiAbbonamento", "placeholders": { terms: config.servizi[window.location.hostname].legal_link.termini, privacy: config.servizi[window.location.hostname].legal_link.termini } })}</span>)
                }
            </div>


        </div>)
    }


    function handleImageError(event, profiloAttuale) {
        console.log("Errore immagine", event.target.src)
        fetch(process.env.REACT_APP_DISPENSER + "/" + profiloAttuale + "/" + country + "/" + context.user_info.cerco)
            .then(response => response.json())
            .then(data => {

                if (data.length > 0) {
                    const main_image = data[0].default_photo.startsWith("https://") ? data[0].default_photo : process.env.REACT_APP_CDN + "/" + default_folder + "/" + profiloAttuale + ".jpg"

                    event.target.src = main_image
                }


            });

    }



    function SwitchImage() {
        //--- metto immagine compliant in caso di flusso 0000

        if (context.fluxId == "0000") {
            return (
                <div className="image_piani_container">
                    <img className="imgVip centerImg" src="/img/header_fluxid0000.jpg" />
                    
                </div>
            )
        }
        if (context.user_info.cerco == "uomo") {
            return (<img className="imgVip centerImg" src="/img/vip_comp.jpg" />)
        }
        if (context.headerAbbonamento.tipo == "fine_crediti") {
            var imageUrl = process.env.REACT_APP_CDN + "/" + default_folder + "/" + context.headerAbbonamento.angelId + ".jpg";
            return (<div className="popupbackground">
                <div className="headerAbbpnamenti">

                    <img onError={(e) => handleImageError(e, context.headerAbbonamento.angelId)} src={imageUrl} alt="" className="imageInHook" />
                    <h4><Lang w={"header_chatta_senza_limiti"} page={"pianiAbbonamento"} placeholders={{ angel: context.headerAbbonamento.angelName }} /></h4>


                    <h5 style={{ marginTop: '10px', fontWeight: 'bold', marginTop: '15px' }}><Lang w={"vuoi_continuare"} page={"pianiAbbonamento"} /></h5>
                </div>
            </div>)
        }
        if (context.headerAbbonamento.tipo == "blurred") {
            var imageUrl = process.env.REACT_APP_CDN + "/" + default_folder + "/" + context.headerAbbonamento.angelId + ".jpg";
            return (<div className="popupbackground">
                <div className="headerAbbpnamenti">

                    <img onError={(e) => handleImageError(e, context.headerAbbonamento.angelId)} src={imageUrl} alt="" className="imageInHook" />
                    <h4>
                        <Lang w={"header_messaggio_offuscato"} page={"pianiAbbonamento"} placeholders={{ angel: context.headerAbbonamento.angelName }} /></h4>

                </div>
            </div>)
        }
        if (context.headerAbbonamento.tipo == "file_like") {
            var imageUrl = process.env.REACT_APP_CDN + "/" + default_folder + "/" + context.headerAbbonamento.angelId + ".jpg";
            return (<div className="popupbackground">
                <div className="headerAbbpnamenti">

                    <img onError={(e) => handleImageError(e, context.headerAbbonamento.angelId)} src={imageUrl} alt="" className="imageInHook" />
                    <h4>
                        <Lang w={"header_fine_like"} page={"pianiAbbonamento"} /></h4>

                </div>
            </div>)
        }
        if (context.headerAbbonamento.tipo == "paginazione") {
            var imageUrl = process.env.REACT_APP_CDN + "/" + default_folder + "/" + context.headerAbbonamento.angelId + ".jpg";
            return (<div className="popupbackground">
                <div className="headerAbbpnamenti">
                    <img onError={(e) => handleImageError(e, context.headerAbbonamento.angelId)} className="imgVip centerImg" src="/img/headerPiani.jpg" />
                    <h4>
                        <Lang w={"header_paginazione"} page={"pianiAbbonamento"} /></h4>
                </div>
            </div>)
        }
        if (context.headerAbbonamento.tipo == "cambia_regione") {
            var imageUrl = process.env.REACT_APP_CDN + "/" + default_folder + "/" + context.headerAbbonamento.angelId + ".jpg";
            return (<div className="popupbackground">
                <div className="headerAbbpnamenti">
                    <img className="imgVip centerImg" src="/img/headerPiani.jpg" />
                    <h4>
                        <Lang w={"header_cambio_regione"} page={"pianiAbbonamento"} /></h4>
                </div>
            </div>)
        }
        if (context.premiumLevel > 0) {
            return (<img className="imgVip centerImg" src="/img/coin.jpg" />)
        }
        return (<div className="popupbackground">
            <div className="headerAbbpnamenti">
                <img className="imgVip centerImg" src="/img/headerPiani.jpg" />
                <h4>
                    <Lang w={"header_paginazione"} page={"pianiAbbonamento"} /></h4>
            </div>
        </div>)
    }







    async function redirOrPurchase(rateplan, index, button) {
        const domain = window.location.hostname;
        console.log("RATEPLAN SCELTO", rateplan);
        try {
            if (index == selected || button) {
                if (context.fluxId != "0000") {

                    if (context.flusso.verificaEta) {

                        context.setRateplanScelto(context.flusso.rateplan.verifica[0])
                        navigate({ pathname: '/purchase/pay' });
                        return
                    }

                    helpers.kpiPanel(context, "scelta_rateplan", rateplan.nomePiano + " - " + rateplan.badge)

                    if (context.actonfile) {
                        console.log("actonfile", context.actonfile)
                        console.log("rateplan", rateplan)
                        const d = new Date();
                        const data = {
                            actonfile: true,
                            clickid: localStorage.getItem("trackerId"),
                            payment_company: config.servizi[domain].payment_company,
                            language: navigator.language,
                            screenHeight: window.screen.height,
                            screenWidth: window.screen.width,
                            timezone: d.getTimezoneOffset(),
                            userAgent: navigator.userAgent,
                            javaEnabled: true,
                            javascriptEnabled: true,
                            screenColorDepth: window.screen.colorDepth,
                            country: helpers.getCountry(),
                            rateplan: rateplan,
                            descriptor: config.servizi[domain].descriptor,
                            city: localStorage.getItem("city"),
                            domain: domain,
                            email: context.email,
                            pacchettone: context.flusso.rateplans?.pacchettone?.id
                        }
                        setSpinner(true)
                        helpers.logToBackend("Tentativo Pagamento", { pixel: true, clickid: localStorage.getItem('trackerId'), et: "tentativo" })

                        GTMEvents.add_payment_info(localStorage.getItem("trackerId"), context.email, window.location.hostname)


                        const response = await helpers.tryCharge(data)
                        console.log("response", response)

                        if (response.status == "ko") {
                            if (response.message == "avoid_duplicate_transaction") {
                                const contenuto = helpers.contenuto_popop_pagamento(response.message)
                                helpers.showPopupgenerico("blocked", context, contenuto)
                            }
                            context.setRateplanScelto(rateplan)
                            navigate({ pathname: '/purchase/pay' });
                        }

                        if (response.status == "open") {
                            if (response.redirect) {
                                const contenuto = helpers.contenuto_popop_pagamento(response.message)
                                //elimino la chiave bottoni da contenuto
                                delete contenuto.bottoni
                                setSpinner(false)
                                helpers.showPopupgenerico("blocked", context, contenuto)
                                setTimeout(function () { window.location.replace(response.redirect) }, 4000);
                                return
                            }
                            const contenuto = helpers.contenuto_popop_pagamento(response.message)
                            setSpinner(false)
                            helpers.showPopupgenerico("blocked", context, contenuto)

                        }

                        if (response.status == "ok") {

                            if (response.threeDS) {
                                //---- PROCEDURA PER 3DS
                                console.log("procedura 3DS", response, response.threeDS)
                                procedura3DS(response)
                                return

                            } else {

                                const credMsg = context.creditiMessaggi + data.rateplan.crediti
                                context.setCreditiMessaggi(credMsg)
                                context.setCustomerId(response.data.customerId)
                                context.setValoreMessaggio(context.flusso.valoreMessaggio)
                                context.setActonfile(true)
                                context.setNewCard(false)

                                //--- se ho una promo tipo pacchettone la mostro, altrimenti vado avanti con popup standard
                                if (response.promo && response.promo.length > 0) {
                                    console.log("ho promo", response.promo)
                                    var contenuto_promo = helpers.contenuto_popop_pagamento("promo")
                                    contenuto_promo.promo = response.promo
                                    setSpinner(false)
                                    console.log("PACCHETTONE OK", contenuto_promo)
                                    helpers.showPopupgenerico("ok_with_promo", context, contenuto_promo)
                                    return
                                }


                                const contenuto = helpers.contenuto_popop_pagamento(response.message)
                                setSpinner(false)
                                helpers.showPopupgenerico("blocked", context, contenuto)


                                setTimeout(function () {
                                    context.Socket.emit('chat', context.messaggioPending);
                                    context.setMessaggioPending(null);
                                    window.location.replace("/chats")
                                }, 6000);
                            }

                        }

                    } else {
                        context.setRateplanScelto(rateplan)

                        helpers.kpiPanel(context, "scelta_rateplan", rateplan.nomePiano + " - " + rateplan.badge)

                        if (context.fluxId != "0000") {
                            //ReactGA.event({ category: 'User',action: 'Scelta rateplan'})
                            navigate({ pathname: '/purchase/pay' });
                            return
                        } else {

                            if (termsCompliant) {
                                //ReactGA.event({ category: 'User',action: 'Scelta rateplan'})
                                navigate({ pathname: '/purchase/pay' });
                                return
                            } else {
                                setActiveError(true)
                            }
                        }
                    }

                } else {
                    if (termsCompliant) {
                        context.setRateplanScelto(rateplan)
                        // ReactGA.event({ category: 'User',action: 'Scelta rateplan'})
                        navigate({ pathname: '/purchase/pay' });
                        return
                    } else {
                        setActiveError(true)
                    }
                }

            } else {

                setSelected(index)
                return
            }
        } catch (err) {
            helpers.logToBackend("Try catch piani abbonamento", { err: err.message })
        }

    }

    function Spinner() {

        if (spinner) {
            return (<div className="waiterAdattivo">
                <div className="spinner-adattivo" role="status">
                    <span className="sr-only"></span>

                </div>
                <div className="testoSpinner">
                    <Lang w={"aggiungiamo_crediti"} page={"pianiAbbonamento"} />
                </div>

            </div>);
        } return false
    }



    async function procedura3DS(res) {
        console.log(res)
        setModule_3ds(res.payment_system)
        setProps_3ds(res)

    }


    useEffect(() => {

        var trackerId = localStorage.getItem('trackerId');
        helpers.logToBackend("Pixel Engage", { pixel: true, clickid: trackerId, et: "engage" })
        helpers.kpiPanel(context, "engage", null, null, null, { canon: "view_plans_credits", dedup: true, meta: { entrypoint: "paywall" }})

        GTMEvents.engaged(localStorage.getItem("trackerId"), context.email, window.location.hostname)
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);


    // restituisce la tipologia_rateplan in base al livello premium dell'utente.
    // compliant se flusso 0000, oppure legge tipo di utente free vs premium e restituisce
    function analisiUtente() {
        if( context.fluxId === "0000") {
            return context.premiumLevel === 0 ? "compliant" : "premium";
        } else {
            return context.premiumLevel === 0 ? "free" : "premium";
        }
    }

    useEffect(() => {
        if (!context.flusso) return;

        const tipologia_utente = analisiUtente();

        console.log("[pianiAbbonamento] Analisi utente:", context.flusso);
        // Una volta che abbiamo il tipo di utente
        // Leggiamo il tipo di flusso ed estraiamo il rateplan del flusso corrispondene a questo tipo di utente
        // Una volta ottenuto l'id corrispondente -> chiamiamo trova rateplan con (id, tipo_utente, country)

        // SE VOGLAIMO FARE CHECK DINAMICO E IN FROTNEND 
        // --> qui va una funzione che in alternativa aldefault ci dia un nuovo id

        // Recuperiamo id rateplan corrispondente direttamente dal flusso

        const id_rateplan = context.flusso.rateplans?.[tipologia_utente]?.id;
        console.log("[pianiAbbonamento] tipologia_utente:", tipologia_utente, "| id_rateplan:", id_rateplan);

        helpers.trovaRateplan({id: id_rateplan, tipologia_utente, country: helpers.getCountry() })
            .then(rateplan => {

                setPlansInfo({ id: rateplan.id, tipologia_rateplan: rateplan.tipologia_rateplan });

                const piani = rateplan ? rateplan.plans : definisciRateplans();
                setPlans(piani);
                setSelected(trovaSelected(piani));
            });

    }, [context.flusso, context.premiumLevel, context.actonfile]);



    return (<div className="all-container bg-light pianiAbbonamentoPage">
        <div className="container filters-no-padding  padding_container" role="main">

            <div className="row">
                <div className="col-md-7 col-12 col-centered">
                    <SwitchImage />
                    <div className="relative">
                        <Spinner />
                        {context.flusso.verificaEta && !context.actonfile && context.premiumLevel === 0 ? (<RenderVerificaEta />) : (<RenderRateplans />)}

                        <Button onClick={() => { redirOrPurchase(plans[selected], selected, true) }}>
                            {context.flusso.verificaEta && !context.actonfile && context.premiumLevel === 0 ? (<Lang w={"testo_bottone_verifica_eta"} page={"pianiAbbonamento"} />) : (<Lang w={"continua"} page={"popupHook"} />)}

                        </Button>

                    </div>

                </div>
            </div>
        </div>

        {context.fluxId !== "0000" && <Recensioni />}


        <PopupGenerico
            show={modalShow}
            onHide={() => setModalShow(false)}
            contenuto={contenuto}
        />

        {module3ds == "adyen" && (<><Module3ds_adyen {...props_3ds} /></>)}
        {module3ds == "trustpay" && (<><Module3ds_trpay {...props_3ds} /></>)}
        {module3ds == "maxpay" && (<><Module3ds_maxpay {...props_3ds} /></>)}
    </div>
    )

}